
  import { computed, defineComponent, PropType } from 'vue'
  import { useQuiz } from '@/api/quiz/quiz'
  import { useRouter } from 'vue-router'
  import { getRouteRecord, RouteRecordId } from '@/model/route-record'
  import { useI18n } from 'vue-i18n'
  import useBem, { useBemProps } from '@/api/bem/bem'

  export default defineComponent({
    props: {
      ...useBemProps,
      btnFacets: {
        type: Array as PropType<Array<string>>,
        default: () => ['primary', 'medium'],
      },
    },
    setup(props) {
      const { t } = useI18n({ useScope: 'global' })
      const { bemAdd } = useBem('reset-btn', props, {})
      const { push } = useRouter()
      const { resetAnswers } = useQuiz()

      const triggerReset = () => {
        resetAnswers()
        push(getRouteRecord(RouteRecordId.Start))
      }

      const btnClasses = computed<Array<string>>(() => {
        return [...props.btnFacets.map((btnFacet) => bemAdd(btnFacet, undefined, 'btn'))]
      })

      return {
        btnClasses,
        t,
        triggerReset,
      }
    },
  })
